type Redirect = {
  to: string;
  target?: "_blank" | "_self" | "_parent" | "_top" | "framename";
};

const externalRedirect = ({
  to,
  target = "_self",
}: Redirect): null => {
  window.open(to, target);
  return null;
};

export default externalRedirect;
